<template>
  <div class="my-3">
    <b-card bg-variant="light" class="my-3">
      <b-row>
        <b-col>
          <h4 class="text-secondary">{{ $t("globals.fieldtracker_service") }}:</h4>
        </b-col>
        <!-- Actions for 'created' status -->
        <b-col v-if="service.status == 'created' && this.getFieldTrackerService.approved == false">
          <b-btn
            v-if="
              getUserBrandPermissions.order_service_edit_request_replace
              && this.edit_service == false
            "
            class="float-right mx-1"
            variant="success"
            size="sm"
            @click="approveService()"
            :disabled="!enableRequest"
          >
            {{ $t("globals.request_fieldtracker") }}
          </b-btn>
          <b-btn
            v-if="
              !edit_service &&
                getUserBrandPermissions.order_service_edit_request_replace
            "
            class="float-right mx-1"
            variant="info"
            size="sm"
            @click="edit_service = true"
          >
            {{ $t("globals.edit") }}
          </b-btn>
          <b-btn
            v-if="edit_service"
            class="float-right mx-1"
            variant="success"
            size="sm"
            @click="saveEdit"
          >
            {{ $t("globals.save") }}
          </b-btn>
          <b-btn
            v-if="edit_service"
            class="float-right mx-1"
            variant="info"
            size="sm"
            @click="cancelEdit"
          >
            {{ $t("globals.cancel") }}
          </b-btn>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col cols="12" md="6">
          <b-row>
            <b-col cols="4">
              <h6 style="margin-top: 4px" class="text-info">
                {{ $t("globals.contact_information") }}:*
              </h6>
            </b-col>
            <b-col>
              <b-form-textarea
                v-model="service.contact_info"
                rows="5"
                :disabled="!edit_service"
              ></b-form-textarea>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!-- Service Devices Table -->
      <ulu-service-devices
        :service="service"
        :refresh="refresh"
        :fieldtrackerService="getFieldTrackerService"
      />
    </b-card>
  </div>
</template>

<style>
.fieldtracker-wrapper {
  overflow: hidden;
  border-radius: 5px;
}

.fieldtracker-heading {
  background-color: #EF6423;
  color: white;
  padding: 2px 10px;
}

.fieldtracker-content {
  padding: 10px;
  border: 1px solid #6c757d;
  -webkit-border-radius: 0 0 5px 5px;
  border-radius: 0 0 5px 5px;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    "ulu-service-devices": () =>
      import("@/components/services/service/ServiceDevices"),
  },
  props: {
    refresh: Function,
    service: {
      type: Object,
      default: () => ({
        id: 0,
        status: "created",
        service_type: "fieldtracker_service",
        trello_card_url: "",
        contact_info: "",
        warranty: false
      })
    }
  },
  data() {
    return {
      edit_service: false,    
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation"]),
    ...mapActions("fieldtracker", ["fetchFieldTrackerService"]),
    cancelEdit() {
      this.edit_service = false;
      this.refresh();
    },
    saveEdit() {
      const data = {
        query: `
          mutation {
            res: ServiceEdit (
              service_id: ${this.service.id},
              contact_info: "${this.service.contact_info}"
            )
          }
        `
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.edit_service = false;
        this.refresh();
      });
    },
    requestService(installation_company) {
      const data = {
        query: `
          mutation {
            res: ServiceInstallRequest (
              service_id: ${this.service.id},
              install_company: "${installation_company}"
            )
          }
        `
      };

      return this.simpleMutation({ data, this_ref: this, skip_confirm: true });
    },
    approveService() {
      if(!confirm(this.$t('globals.are_you_sure'))) {
        return;
      }

      let url = this.getFieldTrackerUrl + "/service_requests/"+this.service.fieldtracker_reference+"/approve";

      fetch(url, { headers: { "Content-Type": "application/json", "Authorization": "Bearer " + this.getFieldtrackerToken }})
        .then((response) => { 
          return response.json();
        })
        .then((data) => {
          if(data.error) {
            throw data.error;
          }

          this.$root.$bvToast.toast(data.message, {
            title: "Success",
            variant: "success",
            noAutoHide: false,
            appendToast: true,
            toaster: "b-toaster-bottom-left"
          });

          return this.requestService("fieldtracker");
        })
        .catch((error) => {
          console.error("error", error);
          this.$root.$bvToast.toast(error, {
            title: "Error",
            variant: "danger",
            noAutoHide: true,
            appendToast: true,
            toaster: "b-toaster-bottom-left"
          });
        });
    },
    loadTrello() {
      let trello_script = document.createElement("script");
      trello_script.setAttribute("src", "https://p.trellocdn.com/embed.min.js");
      document.head.appendChild(trello_script);
    }
  },
  computed: {
    ...mapGetters(["getUserBrandPermissions", "getFieldTrackerUrl"]),
    ...mapGetters("fieldtracker", ["getFieldTrackerService", "getFieldtrackerToken"]),
    enableRequest() {
      return (
        this.service.service_devices.length > 0 &&
        this.service.contact_info != null &&
        this.service.contact_info.length > 3
      );
    }
  },
  mounted() {
    this.loadTrello();
    if(this.service.fieldtracker_reference) {
      this.fetchFieldTrackerService({
        fieldtracker_reference: this.service.fieldtracker_reference,
      });
    }
  },
  watch: {
    $route() {
      this.loadTrello();
    }
  }
};
</script>
